import React from 'react';

import SelectedTick from '../../assets/selected-tick.svg';
import CircleIcon from '../../assets/circle.svg';
import PCIcon from '../../assets/PC1.svg';
import PEIcon from '../../assets/pe02.svg';
import LEIcon from '../../assets/le02.svg';
import AEIcon from '../../assets/ae02.svg';
import StackBundle from '../../assets/sssb.png';
import getSymbolFromCurrency from 'currency-symbol-map';

import './ssproductitem.scss';

export default function SSProductItem(props) {
  const { isClicked, handleItemClicked, product } = props;
  const getIcon = (toolType) => {
    switch (toolType) {
      case 'PC':
        return PCIcon;
      case 'LE':
        return LEIcon;
      case 'AE':
        return AEIcon;
      case 'SB':
        return StackBundle;
      default:
        return PEIcon;
    }
  };

  return (
    <div
      className={
        isClicked && product?.isDisabled
          ? 'tool-container selected disabled'
          : isClicked
          ? 'tool-container selected'
          : product?.isDisabled
          ? 'disabled tool-container'
          : 'tool-container'
      }
      onClick={() => {
        if (product?.isDisabled) return;
        handleItemClicked(product);
      }}
    >
      <div className="tool-icon">
        <img src={getIcon(product.shortName)} alt="" />
      </div>
      <div className="tool-details">
        <div className="name">{product.name}</div>
        <div className="cost">
          {product.shortName === 'SB' ? (
            <>
              <div
                style={{
                  textDecoration: 'line-through',
                  color: '#00D248',
                }}
              >
                {getSymbolFromCurrency(product.currency)}166.99 <span>/ mth</span>
              </div>

              <div className="tool-bundle-cost">
                {' '}
                {getSymbolFromCurrency(product.currency) + product.price} <span>/ mth</span>
              </div>
            </>
          ) : (
            <>
              {getSymbolFromCurrency(product.currency) + product.price} <span>/ mth</span>
            </>
          )}
        </div>
        <div className="percost">PRICE PER SEAT</div>
        {/* <div className="percost-details">
          This team member will have access to the entire Sales Stack Suite and early access to beta releases.
        </div> */}
      </div>
      {product.shortName === 'SB' && (
        <div className="tool-bundle-cost">
          {' '}
          {getSymbolFromCurrency(product.currency) + product.price} <span>/ mth</span>
        </div>
      )}
      {product.shortName === 'SB' && (
        <div className="tool-bundle-icon">
          <img src={LEIcon} alt="" />
          <img src={PCIcon} alt="" />
          <img src={AEIcon} alt="" />
          <img src={PEIcon} alt="" />
        </div>
      )}
      <div className="tool-selection">
        <img src={isClicked ? SelectedTick : CircleIcon} alt="" />
      </div>
    </div>
  );
}
